// extracted by mini-css-extract-plugin
export default {"sort":"AX-z","sortSelect":"BX-z","disabled":"CX-z"};